<template>
  <div class="sidebar-container">
    <div class="menu-wrapper">
      <el-menu ref="menuRef" :default-active="$route.path" class="el-menu-vertical-demo" router background-color="#34495e"
        text-color="#ecf0f1" active-text-color="#42b983" :unique-opened="true" :default-openeds="openedMenus"
        @select="handleMenuSelect">
        <template v-for="item in menuList">
          <!-- 目录（包含子菜单） -->
          <el-submenu v-if="item.menuType === 'M'" :key="item.id" :index="item.id + ''">
            <template slot="title">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.menuName }}</span>
            </template>
            <template v-for="child in item.children">
              <!-- 菜单（无下级） -->
              <el-menu-item v-if="child.menuType === 'C'" :key="child.id" :index="child.path">
                <span slot="title">{{ child.menuName }}</span>
              </el-menu-item>
              <!-- 子目录（递归） -->
              <el-submenu v-if="child.menuType === 'M'" :key="child.id" :index="child.id + ''">
                <template slot="title">
                  <span slot="title">{{ child.menuName }}</span>
                </template>
                <el-menu-item v-for="grandChild in child.children" v-if="grandChild.menuType === 'C'" :key="grandChild.id"
                  :index="grandChild.path">
                  <span slot="title">{{ grandChild.menuName }}</span>
                </el-menu-item>
              </el-submenu>
            </template>
          </el-submenu>
          <!-- 菜单（无下级） -->
          <el-menu-item v-if="item.menuType === 'C'" :key="item.id" :index="item.path"
            :class="{ 'home-menu-item': item.menuName === '首页' }">
            <i :class="item.icon"></i>
            <span slot="title">{{ item.menuName }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </div>
    <div class="sidebar-copyright">
      © 沈阳胜明科技有限公司<br>保留所有权利
    </div>
  </div>
</template>

<script>
import menuApi from '../api/menu'

export default {
  name: 'LeftMenu',
  data() {
    return {
      menuList: [],
      openedMenus: []
    }
  },
  created() {
    this.fetchMenuTree()
  },
  methods: {
    fetchMenuTree() {
      menuApi.findAll().then(response => {  // 使用menuApi调用
        if (response.success) {  // 适配接口返回格式
          this.menuList = response.data.data
        }
      })
    },

    // 菜单选中事件处理
    handleMenuSelect(selectedKey) {
      // 1. 判断选中的是否是“首页”（通过menuList找到选中的菜单项，判断类型和名称）
      const selectedItem = this.findMenuItemByKey(selectedKey)
      if (!selectedItem) return

      // 2. 若选中“首页”（类型C且名称为“首页”），清空展开的子菜单
      if (selectedItem.menuType === 'C' && selectedItem.menuName === '首页') {
        this.openedMenus = []  // 清空数组 → 所有submenu折叠
      }
    },

    // 辅助函数 - 根据选中的key（index）找到对应的菜单项
    findMenuItemByKey(key) {
      // 递归遍历菜单树（处理多级菜单）
      const findItem = (menuList) => {
        for (const item of menuList) {
          // 匹配：menu-item的key是path，submenu的key是id（字符串）
          if (
            (item.menuType === 'C' && item.path === key) ||
            (item.menuType === 'M' && item.id + '' === key)
          ) {
            return item
          }
          // 递归查找子菜单
          if (item.children && item.children.length > 0) {
            const childItem = findItem(item.children)
            if (childItem) return childItem
          }
        }
        return null
      }
      return findItem(this.menuList)
    }
  }
}
</script>

<style scoped>
.sidebar-container {
  width: 200px;
  height: 100%;
  background-color: #34495e;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.menu-wrapper {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

.menu-wrapper .el-menu {
  border-right: none;
}

.sidebar-copyright {
  min-height: 40px;
  line-height: 1.6;
  text-align: center;
  color: #bdc3c7;
  font-size: 12px;
  border-top: 1px solid #2c3e50;
  flex-shrink: 0;
  overflow: hidden;
  padding: 8px 10px;
  box-sizing: border-box;
}

.el-menu-vertical-demo {
  border-right: none;
  height: 100%;
  /* 确保菜单高度充满容器 */
  overflow-y: auto;
  /* 增加滚动支持 */
}

/* ========== 1. 目录（el-submenu）：父级层级 ========== */
::v-deep .el-submenu__title {
  background-color: #34495e !important;
  color: #ffffff !important;
}

::v-deep .el-submenu__title:hover {
  background-color: #1a5276 !important;
  color: #ffffff !important;
}

::v-deep .el-submenu__title.is-active {
  background-color: #1a5276 !important;
  color: #ffffff !important;
}

/* ========== 2. 菜单（el-menu-item）：子级从属 ========== */
::v-deep .el-menu-item {
  background-color: #2c3e50 !important;
  color: #ffffff !important;
}

::v-deep .el-menu-item:hover {
  background-color: #1a5276 !important;
  color: #ffffff !important;
}

::v-deep .el-menu-item.is-active {
  background-color: #103249 !important;
  color: #42b983 !important;
}

/* ========== 3. 首页（el-menu-item）：特殊处理 ========== */
::v-deep .home-menu-item {
  background-color: #34495e !important;
  color: #ffffff !important;
}

::v-deep .home-menu-item:hover {
  background-color: #1a5276 !important;
  color: #ffffff !important;
}

::v-deep .home-menu-item.is-active {
  background-color: #103249 !important;
  color: #42b983 !important;
}
</style>